import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { oesPlatformApps } from "../oesModulesData";

const iconMap: Record<string, React.ReactNode> = {
  admin: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="3" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="12" width="7" height="9" rx="1" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="16" width="7" height="5" rx="1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  examiner: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6 11v5c0 2 2.5 4 6 4s6-2 6-4v-5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  student: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5" />
      <path d="M4 20c0-4 3.5-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  reports: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
};

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const OesWhatWeProvideSection: React.FC = () => (
  <section className="wdev-why" aria-labelledby="oes-provide-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2 id="oes-provide-title" className="wdev-section-head__title">
          What We Provide
        </h2>
        <p className="oes-section-lead">
          Dedicated portals for administrators, examiners, students, and institution management —
          all connected in one examination platform.
        </p>
      </AnimatedSection>

      <div className="wdev-why__grid oes-platform-grid">
        {oesPlatformApps.map((app, index) => (
          <motion.article
            key={app.title}
            className="wdev-why-card oes-platform-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-40px" }}
            custom={index}
            variants={cardVariants}
            whileHover={{ y: -6, transition: { duration: 0.25 } }}
          >
            <div className="wdev-why-card__icon">{iconMap[app.icon]}</div>
            <h3 className="oes-platform-card__title">{app.title}</h3>
            <p className="oes-platform-card__desc">{app.description}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default OesWhatWeProvideSection;
